<template>
  <v-app style="background-color: #f8f9fb">
    <!-- Dialog de Alerta para mensagens gerais -->
    <v-dialog v-model="alertDialog.show" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ alertDialog.title }}</v-card-title>
        <v-card-text class="d-flex justify-center">
          {{ alertDialog.message }}
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn small color="primary" @click="alertDialog.show = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConcluir" max-width="400px" persistent>
      <v-card>
        <v-card-title class="headline">Finalizar Ticket</v-card-title>
        <v-card-text class="pb-0">
          <div class="mb-2">
            <strong>Cliente:</strong> {{ ticketConcluir?.cliente }}
          </div>
          <div class="mb-2">
            <strong>Ticket:</strong> #{{ ticketConcluir?.idTicket }}
          </div>
          <div class="mt-2">Como deseja finalizar este ticket?</div>
          <div class="d-flex justify-center mt-2">
            <v-btn
              color="red"
              small
              :loading="loadingDialogConcluir"
              @click="concluirTicketDevolvidos('falha')"
            >
              Falha na entrega
            </v-btn>
            <v-btn
              color="green"
              small
              :loading="loadingDialogConcluir"
              @click="concluirTicketDevolvidos('entregue')"
            >
              Entregue
            </v-btn>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            text
            color="grey"
            :disabled="loadingDialogConcluir"
            @click="fecharDialogConcluir"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAdicionarEtapa" persistent max-width="800">
      <v-card>
        <v-card-title class="text-h5">
          <h3
            class="mb-2"
            :class="etapaAcao === 'iniciar' ? 'primary--text' : 'success--text'"
          >
            {{ etapaAcao === "iniciar" ? "Iniciar" : "Finalizar" }} etapa <br />
          </h3>

          <v-divider></v-divider>

          <p class="text-caption grey--text mb-2">
            {{
              etapaAcao === "iniciar"
                ? "Registrar início"
                : "Registrar conclusão"
            }}
            da etapa
            <v-chip
              :color="ticketEtapaEditando?.etapa?.cor"
              x-small
              class="ml-1"
              text-color="white"
            >
              {{ ticketEtapaEditando?.etapa?.nome }}
            </v-chip>
          </p>

          <p>Carnê Devolvido #{{ ticketEtapaEditando?.idTicket }}</p>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="etapaTemp.dtInicio"
                  label="Data de Início"
                  type="datetime-local"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="etapaTemp.dtFim"
                  label="Data de Fim"
                  type="datetime-local"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="10" md="10" class="py-0">
                <v-autocomplete
                  v-model="etapaTemp.colaboradores"
                  :items="listaColaboradores"
                  item-text="nome"
                  item-value="id"
                  label="Colaboradores"
                  multiple
                  clearable
                  chips
                  small-chips
                  deletable-chips
                  outlined
                  dense
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip small v-if="index < 2" class="mr-1 mt-2">
                      {{ item.nome }}
                    </v-chip>
                    <span
                      v-if="index === 2"
                      class="grey--text text-caption ml-1 mt-2 d-inline-block"
                    >
                      (+{{ etapaTemp.colaboradores.length - 2 }})
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="2" md="2" class="py-0">
                <v-btn
                  color="primary"
                  small
                  :disabled="!userLogado"
                  @click="adicionarColaboradorLogadoEtapaTemp"
                  title="Adicionar meu usuário"
                >
                  <v-icon>mdi-account-group</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-textarea
                  v-model="etapaTemp.observacao"
                  label="Observação"
                  outlined
                  dense
                  rows="2"
                  auto-grow
                  hide-details
                ></v-textarea>
              </v-col>

              <v-col cols="12" class="pt-2 pb-0">
                <v-btn
                  small
                  text
                  color="primary"
                  @click="toggleAtividadesDialog"
                >
                  <v-icon left>mdi-format-list-bulleted</v-icon>
                  Atividades
                </v-btn>
              </v-col>

              <template v-if="dialogAtividadesAberto">
                <v-col cols="12" class="pt-0">
                  <v-card outlined class="pa-3 mb-2">
                    <h4 class="mb-2">Atividades da Etapa</h4>

                    <v-row>
                      <v-col cols="12">
                        <v-alert
                          v-if="!getEtapaTicketAtualParaAtividadeDialog()"
                          type="warning"
                          dense
                          text
                        >
                          Não foi possível identificar a etapa do ticket.
                          Salve/Inicie a etapa primeiro.
                        </v-alert>

                        <v-card
                          v-else
                          class="pa-3 mb-3"
                          :id="`atividade-form-dialog-${ticketEtapaEditando?.etapa?.id}`"
                          elevation="0"
                        >
                          <v-row>
                            <v-col cols="12" md="6">
                              <v-select
                                v-model="novaAtividadeDialog.atividadeCarneId"
                                :items="
                                  getAtividadesDisponiveisDaEtapaDialog(
                                    ticketEtapaEditando?.etapa?.id
                                  )
                                "
                                item-text="descricao"
                                item-value="id"
                                label="Atividade"
                                outlined
                                dense
                                :disabled="
                                  !getAtividadesDisponiveisDaEtapaDialog(
                                    ticketEtapaEditando?.etapa?.id
                                  ) ||
                                  getAtividadesDisponiveisDaEtapaDialog(
                                    ticketEtapaEditando?.etapa?.id
                                  ).length === 0
                                "
                              ></v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field
                                v-model="novaAtividadeDialog.dtInicio"
                                label="Data/Hora Início"
                                type="datetime-local"
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field
                                v-model="novaAtividadeDialog.dtFim"
                                label="Data/Hora Fim"
                                type="datetime-local"
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-autocomplete
                                v-model="novaAtividadeDialog.colaboradores"
                                :items="listaColaboradores"
                                item-text="nome"
                                item-value="id"
                                label="Colaboradores"
                                multiple
                                clearable
                                chips
                                small-chips
                                deletable-chips
                                outlined
                                dense
                              >
                                <template v-slot:selection="{ item, index }">
                                  <v-chip
                                    small
                                    v-if="index < 2"
                                    class="mr-1 mt-2"
                                  >
                                    {{ item.nome }}
                                  </v-chip>
                                  <span
                                    v-if="
                                      index === 2 &&
                                      (novaAtividadeDialog.colaboradores || [])
                                        .length > 2
                                    "
                                    class="grey--text text-caption ml-1 mt-2 d-inline-block"
                                  >
                                    (+{{
                                      (novaAtividadeDialog.colaboradores || [])
                                        .length - 2
                                    }})
                                  </span>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" class="d-flex justify-end">
                              <v-btn
                                v-if="novaAtividadeDialog.editando"
                                color="red"
                                text
                                small
                                class="mr-2"
                                @click="cancelarEdicaoAtividadeDialog"
                                :disabled="
                                  salvandoAtividadeDialog ===
                                  ticketEtapaEditando?.etapa?.id
                                "
                              >
                                Cancelar
                              </v-btn>

                              <v-btn
                                color="primary"
                                small
                                @click="
                                  novaAtividadeDialog.editando
                                    ? atualizarAtividadeDialog()
                                    : salvarAtividadeDialog()
                                "
                                :loading="
                                  salvandoAtividadeDialog ===
                                  ticketEtapaEditando?.etapa?.id
                                "
                                :disabled="
                                  !atividadeEtapaCompleta(novaAtividadeDialog)
                                "
                              >
                                <v-icon left>
                                  {{
                                    novaAtividadeDialog.editando
                                      ? "mdi-content-save"
                                      : "mdi-plus"
                                  }}
                                </v-icon>
                                {{
                                  novaAtividadeDialog.editando
                                    ? "Atualizar Atividade"
                                    : "Salvar Atividade"
                                }}
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-data-table
                      :headers="atividadesHeaders"
                      :items="atividadesDialog"
                      hide-default-footer
                      dense
                      class="elevation-0"
                      :no-data-text="'Nenhuma atividade registrada nesta etapa'"
                    >
                      <template v-slot:item.atividade="{ item }">
                        {{ item.atividadeCarneDescricao || "-" }}
                      </template>
                      <template v-slot:item.dtInicio="{ item }">
                        {{ formatDateTimeBR(item.dtInicio) || "-" }}
                      </template>
                      <template v-slot:item.dtFim="{ item }">
                        {{ formatDateTimeBR(item.dtFim) || "-" }}
                      </template>
                      <template v-slot:item.colaboradores="{ item }">
                        <div
                          v-if="item.colaboradores && item.colaboradores.length"
                        >
                          <div
                            v-for="(cid, idx) in item.colaboradores"
                            :key="idx"
                          >
                            {{ getNomeColaboradorAtividade(cid) }}
                          </div>
                        </div>
                        <span v-else>-</span>
                      </template>
                      <template v-slot:item.acoes="{ item }">
                        <div class="d-flex align-center">
                          <v-btn
                            text
                            small
                            color="primary"
                            @click="editarAtividadeDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            text
                            small
                            color="red"
                            :loading="excluindoAtividadeDialog === item.id"
                            @click="excluirAtividadeDialog(item)"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </template>
                    </v-data-table>

                    <v-row class="mt-0">
                      <v-col cols="12">
                        <v-card outlined class="pa-4">
                          <h4 class="mb-3">Checklist de Atividades da Etapa</h4>

                          <div
                            v-if="
                              getTodasAtividadesDaEtapa(
                                ticketEtapaEditando?.etapa?.id
                              ).length > 0
                            "
                          >
                            <v-checkbox
                              v-for="atividade in getTodasAtividadesDaEtapa(
                                ticketEtapaEditando?.etapa?.id
                              )"
                              :key="atividade.id"
                              :label="atividade.descricao"
                              :input-value="
                                isAtividadeCadastradaDialog(
                                  atividade.id,
                                  ticketEtapaEditando?.etapa?.id
                                )
                              "
                              disabled
                              color="success"
                              class="my-0"
                            >
                              <template v-slot:label>
                                <span
                                  :class="
                                    isAtividadeCadastradaDialog(
                                      atividade.id,
                                      ticketEtapaEditando?.etapa?.id
                                    )
                                      ? 'success--text font-weight-bold'
                                      : 'grey--text'
                                  "
                                >
                                  {{ atividade.descricao }}
                                  <v-chip
                                    v-if="
                                      isAtividadeCadastradaDialog(
                                        atividade.id,
                                        ticketEtapaEditando?.etapa?.id
                                      )
                                    "
                                    x-small
                                    color="success"
                                    text-color="white"
                                    class="ml-2"
                                  >
                                    ✓ Cadastrada
                                  </v-chip>
                                </span>
                              </template>
                            </v-checkbox>
                          </div>

                          <div v-else class="text-center grey--text">
                            Nenhuma atividade disponível para esta etapa
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </template>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            small
            @click="fecharDialogAdicionarEtapa"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            small
            @click="salvarEtapaTicket"
            :loading="loadingDialogEtapa"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilter" persistent max-width="300">
      <v-card>
        <v-card-title>Mensagem</v-card-title>
        <v-card-text class="d-flex justify-center">
          A Diferença entre as datas não pode ser superior a 90 dias.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="primary" @click="showFilter = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Edição -->
    <v-dialog v-model="dialogEdicao" persistent max-width="800">
      <v-card>
        <v-card-title class="text-h5">
          Carnê Devolvido #{{ ticketEditando?.idTicket }}
          <v-spacer></v-spacer>
          <v-chip small :color="ticketEditando?.etapa?.cor" text-color="white">
            {{ ticketEditando?.etapa?.nome }}
          </v-chip>
        </v-card-title>

        <v-card-text>
          <v-tabs v-model="tabEdicao" background-color="transparent" grow>
            <v-tab>Dados do Ticket</v-tab>
            <v-tab>Etapas</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tabEdicao">
            <v-tab-item>
              <v-container>
                <v-row>
                  <v-col cols="12" class="my-2 pb-0">
                    <h3 class="mb-2 primary--text">Dados do Ticket</h3>
                    <v-divider></v-divider>
                    <p class="text-caption grey--text mb-2">
                      Informações do ticket de carnê devolvido.
                    </p>
                  </v-col>

                  <v-col cols="12" md="6" class="py-0">
                    <v-text-field
                      v-model="ticketEditando.contrato"
                      label="Contrato"
                      outlined
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" class="py-0">
                    <v-text-field
                      v-model="ticketEditando.cliente"
                      label="Cliente"
                      outlined
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" class="py-0">
                    <v-text-field
                      v-model="ticketEditando.tipoTicket"
                      label="Tipo de Ticket"
                      outlined
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" class="py-0">
                    <v-text-field
                      v-model="ticketEditando.dtInicio"
                      label="Data de Início"
                      type="date"
                      outlined
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" class="py-0">
                    <v-text-field
                      v-model="ticketEditando.dtTermino"
                      label="Data de Término"
                      type="date"
                      outlined
                      readonly
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" class="py-0">
                    <v-text-field
                      v-model="ticketEditando.ano"
                      label="Ano"
                      type="number"
                      outlined
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" class="py-0">
                    <v-text-field
                      v-model="ticketEditando.entregador"
                      label="Entregador"
                      outlined
                      readonly
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" class="py-0">
                    <v-text-field
                      v-model="ticketEditando.estagio"
                      label="Estágio"
                      outlined
                      readonly
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" class="py-0">
                    <v-select
                      v-model="ticketEditando.etapa.id"
                      label="Etapa"
                      :items="colunas"
                      item-text="nome"
                      item-value="id"
                      outlined
                      dense
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab-item>
              <v-container>
                <v-row>
                  <v-col cols="12" class="my-2 pb-0">
                    <h3 class="mb-2 primary--text">Gestão Operacional</h3>
                    <v-divider></v-divider>
                    <p class="text-caption grey--text mb-2">
                      Horários e colaboradores responsáveis por etapa.
                    </p>
                  </v-col>

                  <v-col cols="12" class="py-0">
                    <v-expansion-panels v-model="panelEtapas" accordion>
                      <v-expansion-panel
                        v-for="(coluna, index) in colunas.filter(
                          (c) => c.tipo === 'Em andamento'
                        )"
                        :key="coluna.id"
                        class="mb-2 rounded-lg expansion-panel"
                      >
                        <v-expansion-panel-header class="font-weight-medium">
                          <template v-slot:actions>
                            <v-icon color="primary">$expand</v-icon>
                          </template>
                          {{ coluna.nome }}
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <v-card class="pa-1" flat>
                            <v-row dense>
                              <v-col cols="12" md="6">
                                <v-text-field
                                  v-model="
                                    getEtapaRef(ticketEditando, coluna.id)
                                      .dtInicio
                                  "
                                  label="Início"
                                  type="datetime-local"
                                  dense
                                  outlined
                                  hide-details
                                />
                              </v-col>

                              <v-col cols="12" md="6">
                                <v-text-field
                                  v-model="
                                    getEtapaRef(ticketEditando, coluna.id).dtFim
                                  "
                                  label="Fim"
                                  type="datetime-local"
                                  dense
                                  outlined
                                  hide-details
                                />
                              </v-col>

                              <v-col cols="12" class="pb-2">
                                <v-autocomplete
                                  :items="listaColaboradores"
                                  item-text="nome"
                                  item-value="id"
                                  :label="`Colaboradores - ${coluna.nome}`"
                                  multiple
                                  clearable
                                  chips
                                  small-chips
                                  deletable-chips
                                  outlined
                                  dense
                                  hide-details
                                  height="60px"
                                  :value="
                                    getEtapaRef(ticketEditando, coluna.id)
                                      .colaboradores
                                  "
                                  @input="
                                    (val) =>
                                      updateEtapaColaboradores(coluna.id, val)
                                  "
                                >
                                  <template v-slot:selection="{ item, index }">
                                    <v-chip
                                      small
                                      v-if="index < 2"
                                      class="mr-1 mt-2"
                                    >
                                      {{ item.nome }}
                                    </v-chip>
                                    <span
                                      v-if="index === 2"
                                      class="grey--text text-caption ml-1 mt-2 d-inline-block"
                                    >
                                      (+{{
                                        getEtapaRef(ticketEditando, coluna.id)
                                          .colaboradores.length - 2
                                      }})
                                    </span>
                                  </template>
                                </v-autocomplete>
                              </v-col>

                              <v-col cols="12" class="pb-0">
                                <v-textarea
                                  outlined
                                  dense
                                  rows="4"
                                  auto-grow
                                  hide-details
                                  :label="`Observações - ${coluna.nome}`"
                                  :value="
                                    getEtapaRef(ticketEditando, coluna.id)
                                      .observacoes
                                  "
                                  @input="
                                    (val) =>
                                      updateEtapaObservacoes(coluna.id, val)
                                  "
                                ></v-textarea>
                              </v-col>

                              <v-col cols="12" class="pt-2 pb-0">
                                <v-btn
                                  small
                                  text
                                  color="primary"
                                  @click="toggleAtividades(coluna.id)"
                                >
                                  <v-icon left>mdi-format-list-bulleted</v-icon>
                                  Atividades
                                </v-btn>
                              </v-col>

                              <template
                                v-if="etapasComAtividades.includes(coluna.id)"
                              >
                                <v-col cols="12" class="pt-0">
                                  <v-card outlined class="pa-3 mb-3">
                                    <h4 class="mb-2">
                                      Atividades da Etapa - {{ coluna.nome }}
                                    </h4>

                                    <v-row>
                                      <v-col cols="12">
                                        <v-card
                                          class="pa-3 mb-3"
                                          :id="`atividade-form-${coluna.id}`"
                                          elevation="0"
                                        >
                                          <v-row>
                                            <v-col cols="12" md="6">
                                              <v-select
                                                v-model="
                                                  novaAtividadeEtapa[coluna.id]
                                                    .atividadeCarneId
                                                "
                                                :items="
                                                  getAtividadesDisponiveisDaEtapa(
                                                    coluna.id
                                                  )
                                                "
                                                item-text="descricao"
                                                item-value="id"
                                                label="Atividade"
                                                outlined
                                                dense
                                                :disabled="
                                                  !getAtividadesDisponiveisDaEtapa(
                                                    coluna.id
                                                  ) ||
                                                  getAtividadesDisponiveisDaEtapa(
                                                    coluna.id
                                                  ).length === 0
                                                "
                                              ></v-select>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                              <v-text-field
                                                v-model="
                                                  novaAtividadeEtapa[coluna.id]
                                                    .dtInicio
                                                "
                                                label="Data/Hora Início"
                                                type="datetime-local"
                                                outlined
                                                dense
                                              ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                              <v-text-field
                                                v-model="
                                                  novaAtividadeEtapa[coluna.id]
                                                    .dtFim
                                                "
                                                label="Data/Hora Fim"
                                                type="datetime-local"
                                                outlined
                                                dense
                                              ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                              <v-autocomplete
                                                v-model="
                                                  novaAtividadeEtapa[coluna.id]
                                                    .colaboradores
                                                "
                                                :items="listaColaboradores"
                                                item-text="nome"
                                                item-value="id"
                                                label="Colaboradores"
                                                multiple
                                                clearable
                                                chips
                                                small-chips
                                                deletable-chips
                                                outlined
                                                dense
                                              >
                                                <template
                                                  v-slot:selection="{
                                                    item,
                                                    index,
                                                  }"
                                                >
                                                  <v-chip
                                                    small
                                                    v-if="index < 2"
                                                    class="mr-1 mt-2"
                                                  >
                                                    {{ item.nome }}
                                                  </v-chip>
                                                  <span
                                                    v-if="
                                                      index === 2 &&
                                                      (
                                                        novaAtividadeEtapa[
                                                          coluna.id
                                                        ].colaboradores || []
                                                      ).length > 2
                                                    "
                                                    class="grey--text text-caption ml-1 mt-2 d-inline-block"
                                                  >
                                                    (+{{
                                                      (
                                                        novaAtividadeEtapa[
                                                          coluna.id
                                                        ].colaboradores || []
                                                      ).length - 2
                                                    }})
                                                  </span>
                                                </template>
                                              </v-autocomplete>
                                            </v-col>
                                          </v-row>

                                          <v-row>
                                            <v-col
                                              cols="12"
                                              class="d-flex justify-end"
                                            >
                                              <v-btn
                                                v-if="
                                                  novaAtividadeEtapa[coluna.id]
                                                    .editando
                                                "
                                                color="red"
                                                text
                                                small
                                                class="mr-2"
                                                @click="
                                                  cancelarEdicaoAtividade(
                                                    coluna.id
                                                  )
                                                "
                                                :disabled="
                                                  salvandoAtividadeEtapa ===
                                                  coluna.id
                                                "
                                              >
                                                Cancelar
                                              </v-btn>
                                              <v-btn
                                                color="primary"
                                                small
                                                @click="
                                                  novaAtividadeEtapa[coluna.id]
                                                    .editando
                                                    ? atualizarAtividade(
                                                        coluna.id
                                                      )
                                                    : salvarAtividade(coluna.id)
                                                "
                                                :loading="
                                                  salvandoAtividadeEtapa ===
                                                  coluna.id
                                                "
                                                :disabled="
                                                  !atividadeEtapaCompleta(
                                                    novaAtividadeEtapa[
                                                      coluna.id
                                                    ]
                                                  )
                                                "
                                              >
                                                <v-icon left>
                                                  {{
                                                    novaAtividadeEtapa[
                                                      coluna.id
                                                    ].editando
                                                      ? "mdi-content-save"
                                                      : "mdi-plus"
                                                  }}
                                                </v-icon>
                                                {{
                                                  novaAtividadeEtapa[coluna.id]
                                                    .editando
                                                    ? "Atualizar Atividade"
                                                    : "Salvar Atividade"
                                                }}
                                              </v-btn>
                                            </v-col>
                                          </v-row>
                                        </v-card>
                                      </v-col>
                                    </v-row>

                                    <v-data-table
                                      :headers="atividadesHeaders"
                                      :items="getAtividadesDaEtapa(coluna.id)"
                                      hide-default-footer
                                      dense
                                      class="elevation-0"
                                      :no-data-text="'Nenhuma atividade registrada nesta etapa'"
                                    >
                                      <template
                                        v-slot:item.atividade="{ item }"
                                      >
                                        {{
                                          item.atividadeCarneDescricao || "-"
                                        }}
                                      </template>
                                      <template v-slot:item.dtInicio="{ item }">
                                        {{
                                          formatDateTimeBR(item.dtInicio) || "-"
                                        }}
                                      </template>
                                      <template v-slot:item.dtFim="{ item }">
                                        {{
                                          formatDateTimeBR(item.dtFim) || "-"
                                        }}
                                      </template>
                                      <template
                                        v-slot:item.colaboradores="{ item }"
                                      >
                                        <div
                                          v-if="
                                            item.colaboradores &&
                                            item.colaboradores.length > 0
                                          "
                                        >
                                          <div
                                            v-for="(
                                              cid, idx
                                            ) in item.colaboradores"
                                            :key="idx"
                                          >
                                            {{
                                              getNomeColaboradorAtividade(cid)
                                            }}
                                          </div>
                                        </div>
                                        <span v-else>-</span>
                                      </template>
                                      <template v-slot:item.acoes="{ item }">
                                        <div class="d-flex align-center">
                                          <v-btn
                                            text
                                            small
                                            color="primary"
                                            @click="
                                              editarAtividade(coluna.id, item)
                                            "
                                          >
                                            <v-icon>mdi-pencil</v-icon>
                                          </v-btn>
                                          <v-btn
                                            text
                                            small
                                            color="red"
                                            :loading="
                                              excluindoAtividade === item.id
                                            "
                                            @click="
                                              excluirAtividade(coluna.id, item)
                                            "
                                          >
                                            <v-icon>mdi-delete</v-icon>
                                          </v-btn>
                                        </div>
                                      </template>
                                    </v-data-table>

                                    <v-row class="mt-0">
                                      <v-col cols="12">
                                        <v-card outlined class="pa-4">
                                          <h4 class="mb-3">
                                            Checklist de Atividades da Etapa
                                          </h4>

                                          <div
                                            v-if="
                                              getTodasAtividadesDaEtapa(
                                                coluna.id
                                              ).length > 0
                                            "
                                          >
                                            <v-checkbox
                                              v-for="atividade in getTodasAtividadesDaEtapa(
                                                coluna.id
                                              )"
                                              :key="atividade.id"
                                              :label="atividade.descricao"
                                              :input-value="
                                                isAtividadeCadastrada(
                                                  atividade.id,
                                                  coluna.id
                                                )
                                              "
                                              disabled
                                              color="success"
                                              class="my-0"
                                            >
                                              <template v-slot:label>
                                                <span
                                                  :class="
                                                    isAtividadeCadastrada(
                                                      atividade.id,
                                                      coluna.id
                                                    )
                                                      ? 'success--text font-weight-bold'
                                                      : 'grey--text'
                                                  "
                                                >
                                                  {{ atividade.descricao }}
                                                  <v-chip
                                                    v-if="
                                                      isAtividadeCadastrada(
                                                        atividade.id,
                                                        coluna.id
                                                      )
                                                    "
                                                    x-small
                                                    color="success"
                                                    text-color="white"
                                                    class="ml-2"
                                                  >
                                                    ✓ Cadastrada
                                                  </v-chip>
                                                </span>
                                              </template>
                                            </v-checkbox>
                                          </div>

                                          <div
                                            v-else
                                            class="text-center grey--text"
                                          >
                                            Nenhuma atividade disponível para
                                            esta etapa
                                          </div>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                </v-col>
                              </template>
                            </v-row>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text small @click="fecharDialog"
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            small
            @click="salvarEdicao"
            :loading="loadingDialogEdicao"
            >Salvar Alterações</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container style="margin: 0px !important; padding: 0px !important">
      <filtro-component
        :modos="['Data Conclusão']"
        :calendar="'mes'"
        :empresa="true"
        :previda="true"
        @filtrar="filterData"
        ref="filtro"
      >
      </filtro-component>
    </v-container>

    <v-container fluid class="indicadores-container">
      <v-row dense>
        <v-col
          v-for="card in cardsIndicadores"
          :key="card.chave"
          cols="12"
          sm="4"
        >
          <div class="indicador-card-wrapper">
            <base-material-stats-card
              :color="card.cor"
              elevation="1"
              :icon="card.icone"
              :title="card.titulo"
              sub-icon-color="black"
              :value="
                loadingIndicadores
                  ? '...'
                  : formatarNumeroIndicador(card.valor)
              "
              :valuex="false"
              :sub-text="card.subTexto"
            />

            <div class="indicador-info-icon">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    size="20"
                    style="opacity: 0.7"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                <span>{{ card.info }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="background-color: #eee">
      <base-material-card
        icon="mdi-cog-outline"
        color="primary"
        title="Carnês Devolvidos"
        style="margin-top: 20px !important; padding-top: 10px !important"
        class="px-5 py-0"
      >
        <v-row class="pt-4">
          <v-col
            cols="12"
            class="d-flex justify-space-between align-center pb-0"
          >
            <v-chip
              :color="meusTickets ? 'primary' : '#4A4A4A'"
              :text-color="'white'"
              @click="
                meusTickets = !meusTickets;
                init();
              "
              link
              class="px-4 mr-2"
            >
              <v-icon class="mr-2" :color="meusTickets ? 'white' : 'white'">
                mdi-account
              </v-icon>
              Meus Tickets
            </v-chip>

            <v-text-field
              v-model="buscaKanban"
              dense
              outlined
              clearable
              hide-details
              placeholder="Buscar por cliente, contrato ou ID"
              prepend-inner-icon="mdi-magnify"
              style="max-width: 420px"
            ></v-text-field>
          </v-col>
        </v-row>
        <div class="fluxo-view-toolbar">
          <v-btn-toggle
            v-model="boardViewMode"
            mandatory
            class="fluxo-view-toggle"
          >
            <v-btn value="kanban">
              <v-icon size="18" left>mdi-view-dashboard-outline</v-icon>
              Kanban
            </v-btn>

            <v-btn value="table">
              <v-icon size="18" left>mdi-format-list-bulleted</v-icon>
              Lista
            </v-btn>
          </v-btn-toggle>
        </div>

        <div class="pt-3 pb-2">
          <fluxo-tipo-etapa-chips
            v-model="tiposEtapaFiltroSelecionados"
            :items="tiposEtapaFiltroItems"
          />
        </div>

        <!-- Loading -->
        <v-row v-if="loadingPage" class="mt-4">
          <v-col cols="12" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            <p class="mt-2">Carregando tickets...</p>
          </v-col>
        </v-row>

        <div v-else-if="boardViewMode === 'table'" class="ticket-list-view mt-4">
          <v-data-table
            :headers="entregaListHeaders"
            :items="ticketsTabela"
            :items-per-page="25"
            class="ticket-list-table no-hover-effect"
            dense
          >
            <template v-slot:item="row">
              <tr
                :class="{ 'cor-row': row.index % 2 !== 0 }"
                class="pointer"
                @click="abrirDetalhes(row.item)"
              >
                <td class="linha">{{ row.item.idTicket || row.item.id || "-" }}</td>
                <td class="linha">{{ row.item.cliente || "-" }}</td>
                <td class="linha">{{ row.item.contrato || "-" }}</td>
                <td class="linha">{{ row.item.empresa || "-" }}</td>
                <td class="linha">
                  <v-chip
                    x-small
                    :color="row.item.etapa && row.item.etapa.cor"
                    :text-color="
                      row.item.etapa && isColorDark(row.item.etapa.cor)
                        ? 'white'
                        : 'black'
                    "
                  >
                    {{ row.item.etapa ? row.item.etapa.nome : "-" }}
                  </v-chip>
                </td>
                <td class="linha">{{ formatDate(row.item.dtInicio) || "-" }}</td>
                <td class="linha">{{ formatDate(row.item.dtTermino) || "-" }}</td>
                <td class="linha">{{ row.item.entregador || "-" }}</td>
                <td class="linha">{{ row.item.estagio || "-" }}</td>
                <td class="linha">{{ row.item.tipoTicket || "-" }}</td>
                <td class="linha">{{ row.item.ano || "-" }}</td>
              </tr>
            </template>
          </v-data-table>

          <div class="excel-export-row">
            <span
              class="excel-export-icon"
              :class="{ disabled: !ticketsTabela.length }"
              title="Exportar Excel"
              @click="exportarEntregaXlsx"
            >
              <v-progress-circular
                v-if="exportandoEntrega"
                indeterminate
                color="green"
                size="34"
                width="3"
              />
              <i v-else class="fas fa-file-excel"></i>
            </span>
          </div>
        </div>

        <!-- Kanban Board -->
        <v-row v-else align="end" justify="center" class="mb-4 mt-2">
          <div class="kanban-board">
            <div class="kanban-colunas">
              <div
                v-for="(coluna, index) in getColunasFiltradas()"
                :key="index"
                class="kanban-coluna"
              >
                <v-card class="kanban-card" elevation="1" rounded="lg">
                  <div
                    class="kanban-cabecalho pa-4"
                    :style="{ backgroundColor: coluna.cor, opacity: 0.9 }"
                    rounded="t-lg"
                  >
                    <div class="d-flex align-center ga-2">
                      <div
                        class="indicador-coluna"
                        :style="{ backgroundColor: coluna.cor }"
                      ></div>
                      <h3
                        class="text-subtitle-1 font-weight-bold"
                        :class="{
                          'text-white': isColorDark(coluna.cor),
                          'text-black': !isColorDark(coluna.cor),
                        }"
                      >
                        {{ coluna.nome }}
                      </h3>
                      <v-chip color="white" x-small class="text-black ml-2">
                        {{ getTicketsColuna(coluna).length }}
                      </v-chip>
                    </div>
                  </div>

                  <div class="tarefas-container px-3">
                    <draggable
                      :list="getTicketsColuna(coluna)"
                      group="tickets"
                      @change="(event) => aoArrastar(event, coluna)"
                      :animation="200"
                    >
                      <transition-group type="transition" name="fade">
                        <v-card
                          v-for="ticket in getTicketsVisiveisPorColuna(
                            coluna.id
                          )"
                          :key="ticket.id"
                          class="tarefa-card mb-3 mt-2"
                          elevation="1"
                          rounded="lg"
                          :style="`border-left: 6px solid ${coluna.cor}`"
                        >
                          <v-card-text class="text-gray pb-0">
                            <div
                              class="d-flex align-center justify-space-between"
                            >
                              <strong>#{{ ticket.idTicket }}</strong>
                              <v-chip
                                :color="ticket.etapa.cor"
                                x-small
                                :class="{
                                  'text-white': isColorDark(ticket.etapa.cor),
                                  'text-black': !isColorDark(ticket.etapa.cor),
                                }"
                              >
                                {{ ticket.etapa.nome }}
                              </v-chip>
                            </div>
                            <p class="mb-0 mt-2">
                              <strong>Contrato: {{ ticket?.contrato }}</strong>
                            </p>
                            <p class="mb-0">Empresa: {{ ticket.empresa || "-" }}</p>
                            <p class="mb-0">Cliente: {{ ticket.cliente }}</p>
                            <p class="mb-0">Estágio: {{ ticket.estagio }}</p>
                            <p class="mb-0">
                              Entregador:
                              {{ truncateString(ticket.entregador, 16) }}
                            </p>
                          </v-card-text>
                          <v-divider
                            class="my-2"
                            v-if="getInicioAtividade(ticket, ticket.etapa)"
                          ></v-divider>

                          <v-card-text
                            class="text-gray py-0"
                            v-if="
                              ticket.etapa &&
                              ticket.etapa.tipo === 'Em andamento' &&
                              getInicioAtividade(ticket, ticket.etapa)
                            "
                          >
                            <strong
                              >Responsável
                              {{
                                truncateString(ticket.etapa.nome, 18)
                              }}</strong
                            ><br />
                            <div
                              v-html="getResponsavel(ticket, ticket.etapa)"
                            ></div>
                            <strong
                              >Início
                              {{
                                truncateString(ticket.etapa.nome, 22)
                              }}</strong
                            ><br />
                            {{ getInicioAtividade(ticket, ticket.etapa) }}
                          </v-card-text>
                          <v-divider class="my-2"></v-divider>
                          <v-card-actions class="justify-end">
                            <v-btn
                              small
                              :color="coluna.cor"
                              @click="abrirDetalhes(ticket)"
                              title="Ver detalhes"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="mostrarPlay(ticket)"
                              small
                              :color="coluna.cor"
                              :disabled="isEtapaBloqueada(ticket)"
                              @click="handleEtapaAction(ticket, 'iniciar')"
                              title="Iniciar"
                            >
                              <v-icon>mdi-play</v-icon>
                            </v-btn>
                            <v-btn
                              v-else
                              small
                              :color="coluna.cor"
                              :disabled="isEtapaBloqueada(ticket)"
                              @click="handleEtapaAction(ticket, 'finalizar')"
                              title="Finalizar"
                            >
                              <v-icon>mdi-check</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                        <v-card
                          v-if="
                            getTicketsVisiveisPorColunaTotal(coluna.id)
                              .length === 0
                          "
                          key="empty"
                          class="text-center"
                          elevation="0"
                          style="background-color: #fafafa"
                        >
                          <v-card-text>Nenhum ticket encontrado</v-card-text>
                        </v-card>
                      </transition-group>
                    </draggable>

                    <v-btn
                      v-if="temMaisItensColuna(coluna.id)"
                      small
                      text
                      color="primary"
                      class="my-2"
                      @click="carregarMaisItensColuna(coluna.id)"
                    >
                      Carregar mais
                    </v-btn>
                  </div>
                </v-card>
              </div>
            </div>
          </div>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-end align-center mt-4">
            <v-btn color="primary" small @click="init">
              <v-icon>mdi-reload</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </base-material-card>
    </v-container>
  </v-app>
</template>

<script>
import { http } from "@/services/config";
import authHeader from "@/services/auth-header";
import devolvidosService from "@/services/devolvidos";
import rh from "@/services/rh";
import draggable from "vuedraggable";
import FiltroComponent from "./components/FiltroFuneraria.vue";
import FluxoTipoEtapaChips from "./components/FluxoTipoEtapaChips.vue";
import BaseMaterialCard from "@/components/base/MaterialCard.vue";

export default {
  name: "FluxoCarneDevolvidos",
  components: {
    draggable,
    FiltroComponent,
    FluxoTipoEtapaChips,
    BaseMaterialCard,
  },
  data() {
    return {
      // Controle de loading
      loadingPage: false,
      loadingDialogEdicao: false,
      loadingDialogEtapa: false,
      loadingDialogConcluir: false,
      loadingIndicadores: false,

      // Alertas
      alertDialog: {
        show: false,
        title: "",
        message: "",
      },
      showFilter: false,
      selectedStartDate: null,
      selectedEndDate: null,
      selectedCompany: null,

      // Dados
      tickets: [],
      indicadoresCarne: {
        gerados: 0,
        entregues: 0,
        devolvidos: 0,
        clientesAtivosSemParcelaFutura: 0,
        renovacoesPrevistas60Dias: 0,
      },
      colunas: [], // Será preenchido pela API
      tiposEtapaFiltroSelecionados: [],
      tiposEtapaFiltroInicializado: false,
      listaColaboradores: [],
      userLogado: null,
      meusTickets: false,
      buscaKanban: "",
      boardViewMode: "kanban",
      exportandoEntrega: false,

      paginacaoKanban: {
        itensVisiveisPorColuna: {},
        padrao: 5,
        incremento: 5,
      },

      etapasComAtividades: [],
      novaAtividadeEtapa: {},
      atividadesPorTicketEtapaId: {},
      atividadesCarnePorEtapa: {},
      salvandoAtividadeEtapa: null,
      excluindoAtividade: null,
      atividadesHeaders: [
        { text: "Atividade", value: "atividade" },
        { text: "Início", value: "dtInicio" },
        { text: "Fim", value: "dtFim" },
        { text: "Colaboradores", value: "colaboradores" },
        { text: "Ações", value: "acoes", sortable: false },
      ],

      entregaListHeaders: [
        { text: "Ticket", value: "idTicket" },
        { text: "Cliente", value: "cliente" },
        { text: "Contrato", value: "contrato" },
        { text: "Empresa", value: "empresa" },
        { text: "Etapa", value: "etapa.nome" },
        { text: "Inicio", value: "dtInicio" },
        { text: "Termino", value: "dtTermino" },
        { text: "Entregador", value: "entregador" },
        { text: "Estagio", value: "estagio" },
        { text: "Tipo", value: "tipoTicket" },
        { text: "Ano", value: "ano" },
      ],

      dialogAtividadesAberto: false,
      novaAtividadeDialog: {
        id: null,
        atividadeCarneId: null,
        dtInicio: null,
        dtFim: null,
        colaboradores: [],
        editando: false,
      },
      atividadesDialog: [],
      salvandoAtividadeDialog: null,
      excluindoAtividadeDialog: null,

      // Edição
      dialogEdicao: false,
      dialogAdicionarEtapa: false,
      dialogConcluir: false,
      etapaAcao: "iniciar",
      tabEdicao: 0,
      panelEtapas: null,
      ticketEditando: {
        id: null,
        idTicket: null,
        dtInicio: "",
        dtTermino: "",
        entregador: "",
        cliente: "",
        estagio: "",
        etapa: {
          id: null,
          nome: "",
          cor: "",
          tipo: "",
        },
        contrato: "",
        empresa: "",
        tipoTicket: "",
        ano: null,
        etapas: [],
      },

      ticketOriginal: null,

      ticketConcluir: null,

      ticketEtapaEditando: null,
      etapaTemp: {
        dtInicio: "",
        dtFim: "",
        colaboradores: [],
        observacao: "",
      },
    };
  },

  created() {
    this.selectedStartDate = this.getFirstDayOfMonth();
    this.selectedEndDate = this.formatDateBR(this.getDataAtualFormatada(0));
  },

  async mounted() {
    await this.init();
  },

  computed: {
    cardsIndicadores() {
      return [
        {
          chave: "gerados",
          titulo: "Gerados",
          valor: this.indicadoresCarne.gerados,
          icone: "mdi-file-document-plus-outline",
          cor: "blue",
          info:
            "Gerados são considerados pela data de cadastro do ticket no filtro selecionado.",
          subTexto: "Carnês gerados no período",
        },
        {
          chave: "entregues",
          titulo: "Entregues",
          valor: this.indicadoresCarne.entregues,
          icone: "mdi-check-circle-outline",
          cor: "green",
          info:
            "Entregues são considerados pela data de término no filtro selecionado.",
          subTexto: "Entrega concluída",
        },
        {
          chave: "devolvidos",
          titulo: "Devolvidos",
          valor: this.indicadoresCarne.devolvidos,
          icone: "mdi-archive-cancel-outline",
          cor: "red",
          info:
            "Devolvidos são considerados pela data de término no filtro selecionado.",
          subTexto: "Tickets com falha na entrega",
        },
        {
          chave: "clientesAtivosSemParcelaFutura",
          titulo: "Sem Parcela Futura",
          valor: this.indicadoresCarne.clientesAtivosSemParcelaFutura,
          icone: "mdi-calendar-remove-outline",
          cor: "orange",
          info:
            "Clientes ativos de planos que não possuem parcela lançada com vencimento futuro.",
          subTexto: "Clientes ativos sem parcela futura",
        },
        {
          chave: "renovacoesPrevistas60Dias",
          titulo: "Renovações 60d",
          valor: this.indicadoresCarne.renovacoesPrevistas60Dias,
          icone: "mdi-calendar-refresh-outline",
          cor: "purple",
          info:
            "Renovações previstas para os próximos 60 dias, considerando o ciclo atual do contrato.",
          subTexto: "Renovações previstas",
        },
      ];
    },
    ticketsTabela() {
      return this.getTicketsFiltrados();
    },

    tiposEtapaFiltroItems() {
      return this.getTiposEtapaDisponiveis().map((tipo) => ({
        label: tipo,
        color: this.getCorTipoEtapa(tipo),
        count: this.getQuantidadeColunasPorTipo(tipo),
      }));
    },
  },

  methods: {
    async init() {
      await this.buscarEtapas();
      await this.carregarUserLogado();
      await this.consultar_colaboradores();
      await this.carregarAtividadesCarneCatalogo();
      await this.buscarTicketsSeEmpresaUnica();
    },

    async buscarTicketsSeEmpresaUnica() {
      const filtro = this.$refs.filtro;
      const empresasDisponiveis = filtro ? filtro.filteredEmpresas : [];

      if (empresasDisponiveis.length !== 1) {
        return;
      }

      this.selectedCompany = empresasDisponiveis[0];
      await this.buscarTickets(true);
    },

    async carregarUserLogado() {
      try {
        const userLogado = await http.get("/usuario/logado", {
          headers: authHeader(),
        });
        this.userLogado = userLogado.data;
      } catch (e) {
        console.log(e);
        this.userLogado = null;
      }
    },

    async consultar_colaboradores() {
      try {
        const response = await rh.lista_colaboradores_por_departamento(
          "FATURAMENTO"
        );
        this.listaColaboradores = response.data || [];
      } catch (e) {
        console.log(e);
        this.listaColaboradores = [];
      }
    },

    agoraISOParaInput() {
      const d = new Date();

      const pad = (n) => String(n).padStart(2, "0");

      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    getEtapaRegistro(ticket) {
      if (!ticket || !Array.isArray(ticket.etapas)) return null;
      return (
        ticket.etapas.find((e) => e && e.etapaId === ticket.etapa?.id) || null
      );
    },

    formatDateTimeBR(dateTimeString) {
      if (!dateTimeString) return "";

      const valor = String(dateTimeString);
      const partes = valor.split("T");
      if (partes.length < 2) return valor;

      const [year, month, day] = partes[0].split("-");
      const horaMinuto = partes[1].slice(0, 5);

      if (!year || !month || !day) return valor;
      return `${day}/${month}/${year} ${horaMinuto}`;
    },

    getInicioAtividade(element, coluna) {
      if (!element || !element.etapas || !element.etapas.length) return null;

      const etapa = element.etapas.find((e) => e.etapaId === coluna.id);
      if (!etapa || !etapa.dtInicio) return null;

      return this.formatDateTimeBR(etapa.dtInicio);
    },

    getResponsavel(element, coluna) {
      if (!this.listaColaboradores || !this.listaColaboradores.length)
        return "";

      const colaboradoresEtapaIds = [];

      element.etapas.forEach((etapa) => {
        if (etapa.etapaId === coluna.id) {
          colaboradoresEtapaIds.push(...etapa.colaboradores);
        }
      });

      const nomes = this.listaColaboradores
        .filter((colaborador) => colaboradoresEtapaIds.includes(colaborador.id))
        .map((colaborador) => colaborador.nome);

      if (nomes.length === 0) return "Nenhum responsável";

      const listaHtml =
        "<ol>" + nomes.map((nome) => `<li>${nome}</li>`).join("") + "</ol>";
      return listaHtml;
    },

    mostrarPlay(ticket) {
      const registro = this.getEtapaRegistro(ticket);
      return !registro || !registro.dtInicio;
    },

    isEtapaBloqueada(ticket) {
      const tipo = ticket?.etapa?.tipo;
      return tipo === "Falha" || tipo === "Finalizado";
    },

    async handleEtapaAction(ticket, acao) {
      if (!ticket) return;

      if (this.isEtapaBloqueada(ticket)) return;

      if (ticket?.etapa?.tipo === "Agendado") {
        await this.avancarEtapaTicket(ticket);
        return;
      }

      this.abrirDialogEtapaTicket(ticket, acao);
    },

    fecharDialogConcluir() {
      this.dialogConcluir = false;
      this.ticketConcluir = null;
      this.loadingDialogConcluir = false;
    },

    async concluirTicketDevolvidos(opcao) {
      if (!this.ticketConcluir) return;

      const ticketParaAtualizar = JSON.parse(
        JSON.stringify(this.ticketConcluir)
      );

      const etapaFalha = this.colunas.find(
        (c) => c && (c.tipo === "Falha" || c.nome === "Falha")
      );
      const etapaFinalizado = this.colunas.find(
        (c) => c && (c.tipo === "Finalizado" || c.nome === "Finalizado")
      );

      if (opcao === "falha") {
        if (!etapaFalha || !etapaFalha.id) {
          this.exibirAlerta("Erro", "Etapa de Falha não encontrada.");
          return;
        }
        ticketParaAtualizar.etapa.id = etapaFalha.id;
      }

      if (opcao === "entregue") {
        if (!etapaFinalizado || !etapaFinalizado.id) {
          this.exibirAlerta("Erro", "Etapa de Finalizado não encontrada.");
          return;
        }
        ticketParaAtualizar.etapa.id = etapaFinalizado.id;
      }

      this.loadingDialogConcluir = true;

      try {
        await devolvidosService.update(
          ticketParaAtualizar.id,
          ticketParaAtualizar
        );
        await this.buscarTickets(false);
        this.fecharDialogConcluir();
      } catch (error) {
        console.error("Erro ao concluir ticket:", error);
        this.exibirAlerta("Erro", "Ocorreu um erro ao concluir o ticket.");
        await this.buscarTickets(false);
      } finally {
        this.loadingDialogConcluir = false;
      }
    },

    async avancarEtapaTicket(ticket) {
      if (!ticket || !ticket.id) return;

      const ticketParaAtualizar = JSON.parse(JSON.stringify(ticket));
      const etapaIdAtual = Number(ticketParaAtualizar.etapa?.id);
      if (!etapaIdAtual || Number.isNaN(etapaIdAtual)) return;

      ticketParaAtualizar.etapa.id = etapaIdAtual + 1;

      try {
        await devolvidosService.update(
          ticketParaAtualizar.id,
          ticketParaAtualizar
        );
        await this.buscarTickets(false);
      } catch (error) {
        console.error("Erro ao avançar etapa do ticket:", error);
        this.exibirAlerta("Erro", "Ocorreu um erro ao avançar a etapa.");
        await this.buscarTickets(false);
      }
    },

    async buscarEtapas() {
      try {
        const response = await devolvidosService.getAllEtapas();
        if (response.data && response.data.length > 0) {
          this.colunas = response.data.map((etapa) => ({
            id: etapa.id,
            nome: etapa.nome,
            cor: etapa.cor,
            tipo: etapa.tipo,
          }));

          this.colunas.forEach((c) => {
            if (this.paginacaoKanban.itensVisiveisPorColuna[c.id] == null) {
              this.$set(
                this.paginacaoKanban.itensVisiveisPorColuna,
                c.id,
                this.paginacaoKanban.padrao
              );
            }
          });

          this.inicializarFiltroEtapasPadrao();
        }
      } catch (error) {
        console.error("Erro ao buscar etapas:", error);
        this.exibirAlerta("Erro", "Ocorreu um erro ao buscar as etapas.");
      }
    },

    carregarMaisItensColuna(colunaId) {
      if (this.paginacaoKanban.itensVisiveisPorColuna[colunaId] == null) {
        this.$set(
          this.paginacaoKanban.itensVisiveisPorColuna,
          colunaId,
          this.paginacaoKanban.padrao
        );
      }

      const antes = this.paginacaoKanban.itensVisiveisPorColuna[colunaId];
      const depois = antes + this.paginacaoKanban.incremento;

      this.$set(this.paginacaoKanban.itensVisiveisPorColuna, colunaId, depois);
      console.debug("[Kanban] carregarMaisItensColuna", {
        colunaId,
        antes,
        depois,
        total: this.getTicketsVisiveisPorColunaTotal(colunaId).length,
      });
    },

    temMaisItensColuna(colunaId) {
      const total = this.getTicketsVisiveisPorColunaTotal(colunaId).length;
      const visiveis =
        this.paginacaoKanban.itensVisiveisPorColuna[colunaId] ||
        this.paginacaoKanban.padrao;
      return total > visiveis;
    },

    getTicketsVisiveisPorColuna(colunaId) {
      const visiveis =
        this.paginacaoKanban.itensVisiveisPorColuna[colunaId] ||
        this.paginacaoKanban.padrao;
      const itens = this.getTicketsColuna({ id: colunaId }) || [];
      return itens.filter((_, index) => index < visiveis);
    },

    getTicketsVisiveisPorColunaTotal(colunaId) {
      return this.getTicketsColuna({ id: colunaId }) || [];
    },

    async salvarEtapaTicket() {
      if (!this.ticketEtapaEditando) return;

      const dtInicio = this.etapaTemp.dtInicio;
      const dtFim = this.etapaTemp.dtFim;
      const colaboradores = Array.isArray(this.etapaTemp.colaboradores)
        ? this.etapaTemp.colaboradores
        : [];
      const observacao = (this.etapaTemp.observacao || "").trim();

      if (!dtInicio) {
        this.exibirAlerta("Atenção", "Informe a data de início.");
        return;
      }

      if (!colaboradores.length) {
        this.exibirAlerta("Atenção", "Informe ao menos 1 colaborador.");
        return;
      }

      if (dtFim && new Date(dtFim) < new Date(dtInicio)) {
        this.exibirAlerta(
          "Atenção",
          "A data de fim não pode ser menor que a data de início."
        );
        return;
      }

      const novaEtapa = {
        etapaId: this.ticketEtapaEditando.etapa?.id,
        dtInicio,
        dtFim,
        colaboradores,
        observacao,
      };

      if (!Array.isArray(this.ticketEtapaEditando.etapas)) {
        this.ticketEtapaEditando.etapas = [];
      }

      const etapaRef = this.getEtapaRef(
        this.ticketEtapaEditando,
        novaEtapa.etapaId
      );
      etapaRef.dtInicio = novaEtapa.dtInicio;
      etapaRef.dtFim = novaEtapa.dtFim;
      etapaRef.colaboradores = novaEtapa.colaboradores;
      etapaRef.observacoes = novaEtapa.observacao;

      const deveAbrirConclusao = !!dtFim && Number(novaEtapa.etapaId) === 12;

      if (deveAbrirConclusao) {
        this.loadingDialogEtapa = false;
        this.ticketConcluir = JSON.parse(
          JSON.stringify(this.ticketEtapaEditando)
        );
        this.fecharDialogAdicionarEtapa();
        this.dialogConcluir = true;
        return;
      }

      if (dtFim && novaEtapa.etapaId) {
        const etapaIdAtual = Number(novaEtapa.etapaId);
        if (etapaIdAtual && !Number.isNaN(etapaIdAtual)) {
          this.ticketEtapaEditando.etapa.id = etapaIdAtual + 1;
        }
      }

      this.loadingDialogEtapa = true;

      try {
        await devolvidosService.update(
          this.ticketEtapaEditando.id,
          this.ticketEtapaEditando
        );
        await this.buscarTickets(false);

        this.exibirAlerta("Sucesso", "Etapa adicionada com sucesso!");
        this.fecharDialogAdicionarEtapa();
      } catch (error) {
        console.error("Erro ao adicionar etapa no ticket:", error);
        this.exibirAlerta("Erro", "Ocorreu um erro ao adicionar a etapa.");
        await this.buscarTickets(false);
      } finally {
        this.loadingDialogEtapa = false;
      }
    },

    filterData(valores) {
      this.isLoading = true;
      this.selectedStartDate = valores.selectedStartDate;
      this.selectedEndDate = valores.selectedEndDate;
      this.selectedCompany = valores.selectedCompany;

      if (
        this.calcularDiferencaEntreDatas(
          this.selectedStartDate,
          this.selectedEndDate
        ) > 90
      ) {
        this.showFilter = true;
        return;
      }
      this.buscarTickets(true);
    },

    getFirstDayOfMonth() {
      const dataAtual = new Date();
      const primeiroDiaDoMes = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1
      );
      return this.formatDateBR(primeiroDiaDoMes.toISOString().split("T")[0]);
    },

    getDataAtualFormatada(diasAdicionais) {
      const data = new Date();
      data.setDate(data.getDate() + diasAdicionais);
      return `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(data.getDate()).padStart(2, "0")}`;
    },

    formatDate(dateString) {
      if (!dateString) return "";
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },

    truncateString(str, maxLength) {
      if (!str) return "";
      return str.length > maxLength ? str.substring(0, maxLength) + "..." : str;
    },

    formatarNumeroIndicador(valor) {
      const numero = Number(valor || 0);
      return numero.toLocaleString("pt-BR");
    },

    async buscarIndicadores(dataInicio, dataFim) {
      this.loadingIndicadores = true;

      try {
        const response = await devolvidosService.getIndicadores(
          dataInicio,
          dataFim,
          this.selectedCompany
        );

        this.indicadoresCarne = {
          gerados: Number(response.data?.gerados || 0),
          entregues: Number(response.data?.entregues || 0),
          devolvidos: Number(response.data?.devolvidos || 0),
          clientesAtivosSemParcelaFutura: Number(
            response.data?.clientesAtivosSemParcelaFutura || 0
          ),
          renovacoesPrevistas60Dias: Number(
            response.data?.renovacoesPrevistas60Dias || 0
          ),
        };
      } catch (error) {
        console.error("Erro ao buscar indicadores:", error);
        this.indicadoresCarne = {
          gerados: 0,
          entregues: 0,
          devolvidos: 0,
          clientesAtivosSemParcelaFutura: 0,
          renovacoesPrevistas60Dias: 0,
        };
      } finally {
        this.loadingIndicadores = false;
      }
    },

    async buscarTickets(alerta = false) {
      if (alerta) this.loadingPage = true;

      if (!this.selectedStartDate || !this.selectedEndDate) {
        if (alerta) this.loadingPage = false;
        return;
      }

      try {
        // Converter datas para o formato esperado pela API (YYYY-MM-DD)
        const dataInicio = this.converterDataParaFormatoAPI(
          this.selectedStartDate
        );
        const dataFim = this.converterDataParaFormatoAPI(this.selectedEndDate);

        const response = await devolvidosService.getByPeriodo(
          dataInicio,
          dataFim,
          this.selectedCompany
        );
        await this.buscarIndicadores(dataInicio, dataFim);

        if (response.data) {
          let lista = response.data;

          if (this.meusTickets && this.userLogado) {
            lista = lista.filter((ticket) => {
              const registro = this.getEtapaRegistro(ticket);
              return (
                registro &&
                Array.isArray(registro.colaboradores) &&
                registro.colaboradores.includes(this.userLogado)
              );
            });
          }

          this.tickets = lista;
        } else {
          this.tickets = [];
        }
      } catch (error) {
        console.error("Erro ao buscar tickets:", error);
        this.exibirAlerta("Erro", "Ocorreu um erro ao buscar os tickets.");
      } finally {
        if (alerta) this.loadingPage = false;
      }
    },

    validarPeriodo() {
      if (!this.selectedStartDate || !this.selectedEndDate) return false;

      const inicio = new Date(this.selectedStartDate);
      const fim = new Date(this.selectedEndDate);
      const diffTime = Math.abs(fim - inicio);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays <= 90;
    },

    calcularDiferencaEntreDatas(dataInicio, dataFim) {
      if (!dataInicio || !dataFim) return 0;

      const [diaInicio, mesInicio, anoInicio] = dataInicio.split("/");
      const [diaFim, mesFim, anoFim] = dataFim.split("/");

      const inicio = new Date(anoInicio, mesInicio - 1, diaInicio);
      const fim = new Date(anoFim, mesFim - 1, diaFim);

      const diffTime = Math.abs(fim - inicio);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays;
    },

    isColorDark(hexColor) {
      if (!hexColor) return true;

      // Remover o # se existir
      hexColor = hexColor.replace("#", "");

      // Converter para RGB
      const r = parseInt(hexColor.substr(0, 2), 16);
      const g = parseInt(hexColor.substr(2, 2), 16);
      const b = parseInt(hexColor.substr(4, 2), 16);

      // Calcular luminosidade
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

      // Se luminosidade < 0.5, cor é escura
      return luminance < 0.5;
    },

    converterDataParaFormatoAPI(dataBR) {
      if (!dataBR) return "";
      const [dia, mes, ano] = dataBR.split("/");
      return `${ano}-${mes}-${dia}`;
    },

    formatDateBR(date) {
      if (!date) return "";

      if (date.includes("/")) return date;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    getTicketsFiltrados() {
      const query = this.normalizarTexto(this.buscaKanban);
      const filtraQuery = !!query;
      const tiposAtivos = this.getTiposEtapaFiltroAtivos();
      const filtraTipo = tiposAtivos.length > 0;

      return this.tickets.filter((ticket) => {
        if (!ticket || !ticket.etapa) return false;
        if (filtraTipo && !tiposAtivos.includes(ticket.etapa.tipo)) {
          return false;
        }
        if (!filtraQuery) return true;

        const cliente = this.normalizarTexto(ticket.cliente);
        const contrato = this.normalizarTexto(ticket.contrato);
        const empresa = this.normalizarTexto(ticket.empresa);
        const entregador = this.normalizarTexto(ticket.entregador);
        const estagio = this.normalizarTexto(ticket.estagio);
        const idTicket = this.normalizarTexto(ticket.idTicket);
        const id = this.normalizarTexto(ticket.id);

        return (
          cliente.includes(query) ||
          contrato.includes(query) ||
          empresa.includes(query) ||
          entregador.includes(query) ||
          estagio.includes(query) ||
          idTicket.includes(query) ||
          id.includes(query)
        );
      });
    },

    inicializarFiltroEtapasPadrao() {
      const tiposValidos = this.getTiposEtapaDisponiveis();

      this.tiposEtapaFiltroSelecionados =
        this.tiposEtapaFiltroSelecionados.filter((tipo) =>
          tiposValidos.includes(tipo),
        );

      if (this.tiposEtapaFiltroInicializado) return;

      this.tiposEtapaFiltroSelecionados = tiposValidos.filter((tipo) =>
        ["Agendado", "Em andamento"].includes(tipo),
      );
      this.tiposEtapaFiltroInicializado = true;
    },

    getTiposEtapaDisponiveis() {
      return [
        ...new Set(this.colunas.map((coluna) => coluna.tipo).filter(Boolean)),
      ];
    },

    getTiposEtapaFiltroAtivos() {
      return Array.isArray(this.tiposEtapaFiltroSelecionados)
        ? this.tiposEtapaFiltroSelecionados
        : [];
    },

    getQuantidadeColunasPorTipo(tipo) {
      return this.colunas.filter((coluna) => coluna.tipo === tipo).length;
    },

    getCorTipoEtapa(tipo) {
      const coluna = this.colunas.find((item) => item.tipo === tipo);
      return coluna?.cor || "#607d8b";
    },

    getColunasFiltradas() {
      const tiposAtivos = this.getTiposEtapaFiltroAtivos();
      if (!tiposAtivos.length) return this.colunas;

      return this.colunas.filter((coluna) => tiposAtivos.includes(coluna.tipo));
    },

    montarParametrosExportacaoEntrega() {
      return {
        dataInicio: this.converterDataParaFormatoAPI(this.selectedStartDate),
        dataFim: this.converterDataParaFormatoAPI(this.selectedEndDate),
        empresa: this.selectedCompany,
        search: this.buscaKanban || "",
        etapaId: 0,
      };
    },

    async exportarEntregaXlsx() {
      if (this.exportandoEntrega || !this.ticketsTabela.length) {
        return;
      }

      this.exportandoEntrega = true;
      try {
        const response = await devolvidosService.exportar_fluxo_entrega_xls(
          this.montarParametrosExportacaoEntrega(),
        );
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `fluxo_entrega_${Date.now()}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Erro ao exportar fluxo de entrega:", error);
        this.exibirAlerta("Erro", "Erro ao exportar a lista do fluxo de entrega.");
      } finally {
        this.exportandoEntrega = false;
      }
    },

    getTicketsColuna(coluna) {
      const query = this.normalizarTexto(this.buscaKanban);
      const filtraQuery = !!query;

      return this.tickets.filter((ticket) => {
        if (!ticket || !ticket.etapa) return false;
        if (ticket.etapa.id !== coluna.id) return false;

        if (!filtraQuery) return true;

        const cliente = this.normalizarTexto(ticket.cliente);
        const contrato = this.normalizarTexto(ticket.contrato);
        const empresa = this.normalizarTexto(ticket.empresa);
        const idTicket = this.normalizarTexto(ticket.idTicket);
        const id = this.normalizarTexto(ticket.id);

        return (
          cliente.includes(query) ||
          contrato.includes(query) ||
          empresa.includes(query) ||
          idTicket.includes(query) ||
          id.includes(query)
        );
      });
    },

    normalizarTexto(valor) {
      if (valor == null) return "";
      return String(valor).trim().toLowerCase();
    },

    adicionarColaboradorLogadoEtapaTemp() {
      if (!this.userLogado) return;

      if (!Array.isArray(this.etapaTemp.colaboradores)) {
        this.etapaTemp.colaboradores = [];
      }

      if (this.etapaTemp.colaboradores.includes(this.userLogado)) return;

      this.etapaTemp.colaboradores.push(this.userLogado);
    },

    abrirDetalhes(ticket) {
      this.ticketEditando = JSON.parse(JSON.stringify(ticket));
      this.ticketOriginal = JSON.parse(JSON.stringify(ticket));
      this.tabEdicao = 0;
      this.panelEtapas = null;
      this.dialogEdicao = true;
    },

    getEtapaRef(ticket, etapaId) {
      if (!ticket) return {};

      if (!Array.isArray(ticket.etapas)) {
        ticket.etapas = [];
      }

      let etapa = ticket.etapas.find((e) => e && e.etapaId === etapaId);
      if (!etapa) {
        etapa = {
          id: null,
          etapaId,
          dtInicio: "",
          dtFim: "",
          colaboradores: [],
          observacoes: "",
          atividades: [],
        };
        ticket.etapas.push(etapa);
      }

      if (!Array.isArray(etapa.colaboradores)) etapa.colaboradores = [];
      if (!etapa.observacoes) etapa.observacoes = "";

      return etapa;
    },

    toggleAtividades(etapaId) {
      if (!etapaId) return;

      const index = this.etapasComAtividades.indexOf(etapaId);
      if (index > -1) {
        this.etapasComAtividades.splice(index, 1);
      } else {
        this.etapasComAtividades.push(etapaId);
        this.initNovaAtividadeEtapa(etapaId);
        this.carregarAtividadesEtapa(etapaId);
      }
    },

    initNovaAtividadeEtapa(etapaId) {
      if (!etapaId) return;

      this.$set(this.novaAtividadeEtapa, etapaId, {
        id: null,
        ticketCarneEtapaId: null,
        atividadeCarneId: null,
        dtInicio: null,
        dtFim: null,
        colaboradores: [],
        editando: false,
      });
    },

    async carregarAtividadesCarneCatalogo() {
      try {
        const response = await devolvidosService.getAtividadesCarne();
        const lista = Array.isArray(response.data) ? response.data : [];

        const porEtapa = {};
        lista.forEach((a) => {
          if (!a || a.etapaId == null) return;
          if (!porEtapa[a.etapaId]) porEtapa[a.etapaId] = [];
          porEtapa[a.etapaId].push(a);
        });

        Object.keys(porEtapa).forEach((k) => {
          porEtapa[k] = porEtapa[k].sort((x, y) =>
            String(x.descricao).localeCompare(String(y.descricao))
          );
        });

        this.atividadesCarnePorEtapa = porEtapa;
      } catch (e) {
        console.error(e);
        this.atividadesCarnePorEtapa = {};
      }
    },

    getAtividadesCarneDaEtapa(etapaId) {
      return this.atividadesCarnePorEtapa?.[etapaId] || [];
    },

    getTodasAtividadesDaEtapa(etapaId) {
      return this.getAtividadesCarneDaEtapa(etapaId);
    },

    isAtividadeCadastrada(atividadeId, etapaId) {
      const atividades = this.getAtividadesDaEtapa(etapaId);
      return atividades.some((a) => a && a.atividadeCarneId === atividadeId);
    },

    getAtividadesDisponiveisDaEtapa(etapaId) {
      const todas = this.getAtividadesCarneDaEtapa(etapaId);
      if (!todas || !todas.length) return [];

      const atividades = this.getAtividadesDaEtapa(etapaId);
      const usadas = new Set(
        (atividades || [])
          .map((a) => a && a.atividadeCarneId)
          .filter((id) => id != null)
      );

      return todas.filter((a) => a && !usadas.has(a.id));
    },

    getEtapaTicketAtualParaAtividade(etapaId) {
      const etapaTicket = this.getEtapaRef(this.ticketEditando, etapaId);
      if (!etapaTicket || !etapaTicket.id) return null;
      return etapaTicket;
    },

    async carregarAtividadesEtapa(etapaId) {
      const etapaTicket = this.getEtapaTicketAtualParaAtividade(etapaId);
      if (!etapaTicket) {
        this.exibirAlerta(
          "Atenção",
          "Não foi possível identificar a etapa do ticket. Salve/Inicie a etapa primeiro."
        );
        return;
      }

      try {
        const response =
          await devolvidosService.getEtapaAtividadesByTicketEtapaId(
            etapaTicket.id
          );
        this.$set(
          this.atividadesPorTicketEtapaId,
          etapaTicket.id,
          response.data || []
        );
      } catch (e) {
        console.error(e);
        this.$set(this.atividadesPorTicketEtapaId, etapaTicket.id, []);
      }
    },

    getAtividadesDaEtapa(etapaId) {
      const etapaTicket = this.getEtapaTicketAtualParaAtividade(etapaId);
      if (!etapaTicket) return [];
      return this.atividadesPorTicketEtapaId[etapaTicket.id] || [];
    },

    atividadeEtapaCompleta(atividade) {
      if (!atividade) return false;
      return (
        !!atividade.atividadeCarneId &&
        !!atividade.dtInicio &&
        Array.isArray(atividade.colaboradores) &&
        atividade.colaboradores.length > 0
      );
    },

    cancelarEdicaoAtividade(etapaId) {
      this.initNovaAtividadeEtapa(etapaId);
    },

    editarAtividade(etapaId, atividade) {
      this.initNovaAtividadeEtapa(etapaId);

      const etapaTicket = this.getEtapaTicketAtualParaAtividade(etapaId);
      if (!etapaTicket) return;

      this.$set(this.novaAtividadeEtapa, etapaId, {
        id: atividade.id,
        ticketCarneEtapaId: atividade.ticketCarneEtapaId,
        atividadeCarneId: atividade.atividadeCarneId,
        dtInicio: (atividade.dtInicio || "").slice(0, 16),
        dtFim: atividade.dtFim ? String(atividade.dtFim).slice(0, 16) : null,
        colaboradores: Array.isArray(atividade.colaboradores)
          ? atividade.colaboradores
          : [],
        editando: true,
      });

      const formElement = document.getElementById(`atividade-form-${etapaId}`);
      if (formElement) {
        formElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },

    parseDateTimeLocal(valor) {
      if (!valor) return null;
      const d = new Date(valor);
      if (Number.isNaN(d.getTime())) return null;
      return d;
    },

    validarDatasAtividade(etapaTicket, atividade) {
      const inicioAtividade = this.parseDateTimeLocal(atividade.dtInicio);
      const fimAtividade = this.parseDateTimeLocal(atividade.dtFim);
      const inicioEtapa = this.parseDateTimeLocal(etapaTicket.dtInicio);
      const fimEtapa = this.parseDateTimeLocal(etapaTicket.dtFim);

      if (!inicioAtividade)
        return { valid: false, message: "Data de início inválida." };
      if (inicioEtapa && inicioAtividade < inicioEtapa) {
        return {
          valid: false,
          message:
            "A data de início da atividade deve ser maior que a data de início da etapa",
        };
      }
      if (fimAtividade && inicioAtividade && fimAtividade < inicioAtividade) {
        return {
          valid: false,
          message: "A data de fim não pode ser menor que a data de início.",
        };
      }
      if (fimEtapa && fimAtividade && fimAtividade > fimEtapa) {
        return {
          valid: false,
          message:
            "A data de fim da atividade deve ser menor que a data de fim da etapa",
        };
      }
      return { valid: true, message: "" };
    },

    async salvarAtividade(etapaId) {
      this.salvandoAtividadeEtapa = etapaId;
      try {
        const etapaTicket = this.getEtapaTicketAtualParaAtividade(etapaId);
        if (!etapaTicket) {
          this.exibirAlerta(
            "Erro",
            "Não foi possível identificar a etapa do ticket. Salve/Inicie a etapa primeiro"
          );
          return;
        }

        const atividade = this.novaAtividadeEtapa[etapaId];
        const validacao = this.validarDatasAtividade(etapaTicket, atividade);
        if (!validacao.valid) {
          this.exibirAlerta("Erro", validacao.message);
          return;
        }

        const dto = {
          ticketCarneEtapaId: etapaTicket.id,
          atividadeCarneId: atividade.atividadeCarneId,
          dtInicio: atividade.dtInicio,
          dtFim: atividade.dtFim || null,
          colaboradores: Array.isArray(atividade.colaboradores)
            ? atividade.colaboradores
            : [],
        };

        await devolvidosService.createEtapaAtividade(dto);
        this.initNovaAtividadeEtapa(etapaId);
        await this.carregarAtividadesEtapa(etapaId);
        this.exibirAlerta("Sucesso", "Atividade adicionada com sucesso!");
      } catch (e) {
        console.error(e);
        this.exibirAlerta("Erro", "Ocorreu um erro ao salvar a atividade.");
      } finally {
        this.salvandoAtividadeEtapa = null;
      }
    },

    async atualizarAtividade(etapaId) {
      this.salvandoAtividadeEtapa = etapaId;
      try {
        const etapaTicket = this.getEtapaTicketAtualParaAtividade(etapaId);
        if (!etapaTicket) {
          this.exibirAlerta(
            "Erro",
            "Não foi possível identificar a etapa do ticket. Salve/Inicie a etapa primeiro"
          );
          return;
        }

        const atividade = this.novaAtividadeEtapa[etapaId];
        if (!atividade || !atividade.id) {
          this.exibirAlerta(
            "Erro",
            "Nenhuma atividade selecionada para edição."
          );
          return;
        }

        const validacao = this.validarDatasAtividade(etapaTicket, atividade);
        if (!validacao.valid) {
          this.exibirAlerta("Erro", validacao.message);
          return;
        }

        const dto = {
          ticketCarneEtapaId: etapaTicket.id,
          atividadeCarneId: atividade.atividadeCarneId,
          dtInicio: atividade.dtInicio,
          dtFim: atividade.dtFim || null,
          colaboradores: Array.isArray(atividade.colaboradores)
            ? atividade.colaboradores
            : [],
        };

        await devolvidosService.updateEtapaAtividade(atividade.id, dto);
        this.initNovaAtividadeEtapa(etapaId);
        await this.carregarAtividadesEtapa(etapaId);
        this.exibirAlerta("Sucesso", "Atividade atualizada com sucesso!");
      } catch (e) {
        console.error(e);
        this.exibirAlerta("Erro", "Ocorreu um erro ao atualizar a atividade.");
      } finally {
        this.salvandoAtividadeEtapa = null;
      }
    },

    async excluirAtividade(etapaId, atividade) {
      if (!atividade || !atividade.id) return;
      if (!confirm("Tem certeza que deseja excluir esta atividade?")) return;

      this.excluindoAtividade = atividade.id;
      try {
        await devolvidosService.deleteEtapaAtividade(atividade.id);
        await this.carregarAtividadesEtapa(etapaId);
        this.exibirAlerta("Sucesso", "Atividade excluída com sucesso!");
      } catch (e) {
        console.error(e);
        this.exibirAlerta("Erro", "Ocorreu um erro ao excluir a atividade.");
      } finally {
        this.excluindoAtividade = null;
      }
    },

    getNomeColaboradorAtividade(colaboradorId) {
      const colaborador = Array.isArray(this.listaColaboradores)
        ? this.listaColaboradores.find((c) => c && c.id === colaboradorId)
        : null;
      return colaborador ? colaborador.nome : "-";
    },

    updateEtapaColaboradores(etapaId, colaboradores) {
      const etapa = this.getEtapaRef(this.ticketEditando, etapaId);
      etapa.colaboradores = Array.isArray(colaboradores) ? colaboradores : [];
    },

    updateEtapaObservacoes(etapaId, observacoes) {
      const etapa = this.getEtapaRef(this.ticketEditando, etapaId);
      etapa.observacoes = observacoes;
    },

    abrirDialogEtapaTicket(ticket, acao) {
      this.etapaAcao = acao;
      this.ticketEtapaEditando = JSON.parse(JSON.stringify(ticket));

      const registroExistente = this.getEtapaRegistro(this.ticketEtapaEditando);

      this.etapaTemp = {
        dtInicio: registroExistente?.dtInicio || "",
        dtFim: registroExistente?.dtFim || "",
        colaboradores: Array.isArray(registroExistente?.colaboradores)
          ? registroExistente.colaboradores
          : [],
        observacao: registroExistente?.observacoes || "",
      };

      if (this.etapaAcao === "iniciar" && !this.etapaTemp.dtInicio) {
        this.etapaTemp.dtInicio = this.agoraISOParaInput();
      }

      if (this.etapaAcao === "finalizar" && !this.etapaTemp.dtFim) {
        this.etapaTemp.dtFim = this.agoraISOParaInput();
      }

      this.dialogAtividadesAberto = false;
      this.resetNovaAtividadeDialog();
      this.atividadesDialog = [];
      this.salvandoAtividadeDialog = null;
      this.excluindoAtividadeDialog = null;

      this.dialogAdicionarEtapa = true;
    },

    fecharDialogAdicionarEtapa() {
      this.dialogAdicionarEtapa = false;
      this.ticketEtapaEditando = null;
      this.dialogAtividadesAberto = false;
      this.resetNovaAtividadeDialog();
      this.atividadesDialog = [];
      this.etapaTemp = {
        dtInicio: "",
        dtFim: "",
        colaboradores: [],
        observacao: "",
      };
    },

    resetNovaAtividadeDialog() {
      this.novaAtividadeDialog = {
        id: null,
        atividadeCarneId: null,
        dtInicio: null,
        dtFim: null,
        colaboradores: [],
        editando: false,
      };
    },

    toggleAtividadesDialog() {
      this.dialogAtividadesAberto = !this.dialogAtividadesAberto;
      if (this.dialogAtividadesAberto) {
        this.resetNovaAtividadeDialog();
        this.carregarAtividadesDialog();
      }
    },

    getEtapaTicketAtualParaAtividadeDialog() {
      if (!this.ticketEtapaEditando || !this.ticketEtapaEditando.etapa)
        return null;
      const etapaId = this.ticketEtapaEditando.etapa.id;
      const etapaTicket = this.getEtapaRef(this.ticketEtapaEditando, etapaId);
      if (!etapaTicket || !etapaTicket.id) return null;
      return etapaTicket;
    },

    async carregarAtividadesDialog() {
      const etapaTicket = this.getEtapaTicketAtualParaAtividadeDialog();
      if (!etapaTicket) return;

      try {
        const response =
          await devolvidosService.getEtapaAtividadesByTicketEtapaId(
            etapaTicket.id
          );
        this.atividadesDialog = response.data || [];
      } catch (e) {
        console.error(e);
        this.atividadesDialog = [];
      }
    },

    isAtividadeCadastradaDialog(atividadeId, etapaId) {
      const lista = Array.isArray(this.atividadesDialog)
        ? this.atividadesDialog
        : [];
      return lista.some((a) => a && a.atividadeCarneId === atividadeId);
    },

    getAtividadesDisponiveisDaEtapaDialog(etapaId) {
      const todas = this.getAtividadesCarneDaEtapa(etapaId);
      if (!todas || !todas.length) return [];

      const usadas = new Set(
        (this.atividadesDialog || [])
          .map((a) => a && a.atividadeCarneId)
          .filter((id) => id != null)
      );
      return todas.filter((a) => a && !usadas.has(a.id));
    },

    cancelarEdicaoAtividadeDialog() {
      this.resetNovaAtividadeDialog();
    },

    editarAtividadeDialog(atividade) {
      if (!atividade) return;
      this.novaAtividadeDialog = {
        id: atividade.id,
        atividadeCarneId: atividade.atividadeCarneId,
        dtInicio: (atividade.dtInicio || "").slice(0, 16),
        dtFim: atividade.dtFim ? String(atividade.dtFim).slice(0, 16) : null,
        colaboradores: Array.isArray(atividade.colaboradores)
          ? atividade.colaboradores
          : [],
        editando: true,
      };

      const etapaId = this.ticketEtapaEditando?.etapa?.id;
      const formElement = document.getElementById(
        `atividade-form-dialog-${etapaId}`
      );
      if (formElement) {
        formElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },

    async salvarAtividadeDialog() {
      const etapaId = this.ticketEtapaEditando?.etapa?.id;
      this.salvandoAtividadeDialog = etapaId;
      try {
        const etapaTicket = this.getEtapaTicketAtualParaAtividadeDialog();
        if (!etapaTicket) return;

        const validacao = this.validarDatasAtividade(
          etapaTicket,
          this.novaAtividadeDialog
        );
        if (!validacao.valid) {
          this.exibirAlerta("Erro", validacao.message);
          return;
        }

        const dto = {
          ticketCarneEtapaId: etapaTicket.id,
          atividadeCarneId: this.novaAtividadeDialog.atividadeCarneId,
          dtInicio: this.novaAtividadeDialog.dtInicio,
          dtFim: this.novaAtividadeDialog.dtFim || null,
          colaboradores: Array.isArray(this.novaAtividadeDialog.colaboradores)
            ? this.novaAtividadeDialog.colaboradores
            : [],
        };

        await devolvidosService.createEtapaAtividade(dto);
        this.resetNovaAtividadeDialog();
        await this.carregarAtividadesDialog();
        this.exibirAlerta("Sucesso", "Atividade adicionada com sucesso!");
      } catch (e) {
        console.error(e);
        this.exibirAlerta("Erro", "Ocorreu um erro ao salvar a atividade.");
      } finally {
        this.salvandoAtividadeDialog = null;
      }
    },

    async atualizarAtividadeDialog() {
      const etapaId = this.ticketEtapaEditando?.etapa?.id;
      this.salvandoAtividadeDialog = etapaId;
      try {
        const etapaTicket = this.getEtapaTicketAtualParaAtividadeDialog();
        if (!etapaTicket) return;
        if (!this.novaAtividadeDialog.id) return;

        const validacao = this.validarDatasAtividade(
          etapaTicket,
          this.novaAtividadeDialog
        );
        if (!validacao.valid) {
          this.exibirAlerta("Erro", validacao.message);
          return;
        }

        const dto = {
          ticketCarneEtapaId: etapaTicket.id,
          atividadeCarneId: this.novaAtividadeDialog.atividadeCarneId,
          dtInicio: this.novaAtividadeDialog.dtInicio,
          dtFim: this.novaAtividadeDialog.dtFim || null,
          colaboradores: Array.isArray(this.novaAtividadeDialog.colaboradores)
            ? this.novaAtividadeDialog.colaboradores
            : [],
        };

        await devolvidosService.updateEtapaAtividade(
          this.novaAtividadeDialog.id,
          dto
        );
        this.resetNovaAtividadeDialog();
        await this.carregarAtividadesDialog();
        this.exibirAlerta("Sucesso", "Atividade atualizada com sucesso!");
      } catch (e) {
        console.error(e);
        this.exibirAlerta("Erro", "Ocorreu um erro ao atualizar a atividade.");
      } finally {
        this.salvandoAtividadeDialog = null;
      }
    },

    async excluirAtividadeDialog(atividade) {
      if (!atividade || !atividade.id) return;
      if (!confirm("Tem certeza que deseja excluir esta atividade?")) return;

      this.excluindoAtividadeDialog = atividade.id;
      try {
        await devolvidosService.deleteEtapaAtividade(atividade.id);
        await this.carregarAtividadesDialog();
        this.exibirAlerta("Sucesso", "Atividade excluída com sucesso!");
      } catch (e) {
        console.error(e);
        this.exibirAlerta("Erro", "Ocorreu um erro ao excluir a atividade.");
      } finally {
        this.excluindoAtividadeDialog = null;
      }
    },

    fecharDialog() {
      this.dialogEdicao = false;
      this.ticketEditando = {
        id: null,
        idTicket: null,
        dtInicio: "",
        dtTermino: "",
        entregador: "",
        cliente: "",
        estagio: "",
        etapa: {
          id: null,
          nome: "",
          cor: "",
          tipo: "",
        },
        contrato: "",
        tipoTicket: "",
        ano: null,
        etapas: [],
      };
      this.ticketOriginal = null;
    },

    async salvarEdicao() {
      if (!this.ticketEditando) return;

      this.loadingDialogEdicao = true;

      try {
        await devolvidosService.update(
          this.ticketEditando.id,
          this.ticketEditando
        );

        // Atualizar a lista de tickets
        await this.buscarTickets(false);

        this.exibirAlerta("Sucesso", "Ticket atualizado com sucesso!");
        this.fecharDialog();
      } catch (error) {
        console.error("Erro ao salvar ticket:", error);
        this.exibirAlerta("Erro", "Ocorreu um erro ao salvar as alterações.");
      } finally {
        this.loadingDialogEdicao = false;
      }
    },

    async aoArrastar(event, novaEtapa) {
      let ticketArrastado = event.added?.element;
      const etapaDestino = novaEtapa;

      if (!ticketArrastado || !ticketArrastado.etapa) return;
      if (!etapaDestino || !etapaDestino.id) return;

      // Se não houver mudança de coluna, não faz nada
      if (ticketArrastado.etapa.id === etapaDestino.id) return;

      ticketArrastado.etapa.id = etapaDestino.id;

      this.loadingPage = true;

      try {
        await devolvidosService.update(ticketArrastado.id, ticketArrastado);
        await this.buscarTickets(true);
      } catch (error) {
        console.error("Erro ao atualizar etapa do ticket:", error);
        this.exibirAlerta("Erro", "Ocorreu um erro ao mover o ticket.");
        await this.buscarTickets(true);
      } finally {
        this.loadingPage = false;
      }
    },

    exibirAlerta(titulo, mensagem) {
      this.alertDialog = {
        show: true,
        title: titulo,
        message: mensagem,
      };
    },
  },
};
</script>

<style scoped>
.fluxo-view-toolbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 26px;
  margin-bottom: 8px;
  width: 100%;
}

.fluxo-view-toggle {
  display: inline-flex;
  padding: 0;
  background: #f8fafc;
  overflow: hidden;
}

.fluxo-view-toggle .v-btn {
  box-shadow: none !important;
  border-radius: 0 !important;
  min-width: 86px !important;
  height: 34px !important;
  text-transform: none;
  letter-spacing: 0;
  font-size: 12px;
  font-weight: 600;
  color: #475569 !important;
  background: transparent !important;
  transition: 0.18s;
}

.fluxo-view-toggle .v-btn:first-child {
  border-radius: 5px 0 0 5px !important;
}

.fluxo-view-toggle .v-btn:last-child {
  border-radius: 0 5px 5px 0 !important;
}

.fluxo-view-toggle .v-btn--active {
  background: #111827 !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18) !important;
}

.fluxo-view-toggle .v-btn--active .v-icon {
  color: white !important;
}

.fluxo-view-toggle .v-btn .v-icon {
  margin-right: 6px;
}

.excel-export-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.excel-export-icon {
  color: green;
  font-size: 48px;
  line-height: 1;
  margin-right: 12px;
  cursor: pointer;
  min-width: 48px;
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.excel-export-icon.disabled {
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.65;
}

.ticket-list-view {
  overflow: visible;
}

.ticket-list-table {
  background: #fff;
}

.linha {
  font-size: 11px !important;
  font-weight: normal;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.cor-row {
  background-color: #f8ded4;
  transition: none !important;
}

.indicadores-container {
  background-color: #eee;
  padding-bottom: 0;
}

.indicador-card-wrapper {
  position: relative;
}

.indicador-info-icon {
  position: absolute;
  right: 12px;
  bottom: 12px;
  cursor: pointer;
  z-index: 2;
}

.kanban-container {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 0;
}

.kanban-board {
  padding: 16px;
  overflow-x: auto;
  padding-top: 0;
}

.kanban-colunas {
  display: flex;
  gap: 16px;
  min-height: calc(100vh - 30vh);
}

.kanban-coluna {
  min-width: 280px;
  max-width: 320px;
  flex-shrink: 0;
}

.kanban-card {
  display: flex;
  flex-direction: column;
  background: #fafafa;
}

.kanban-cabecalho {
  border-bottom: 1px solid #e0e0e0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.indicador-coluna {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.tarefas-container {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.tarefa-card {
  cursor: pointer;
  transition: 0.2s ease;
  background: white;
  border: 1px solid #e0e0e0;
}

.tarefa-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-adicionar {
  margin-top: 8px;
  min-height: 32px !important;
  font-size: 0.8rem !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.text-gray {
  color: #616161 !important;
}

.text-white {
  color: white;
}
.text-black {
  color: black;
}
.card-placeholder {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.4;
  border: 2px dashed #ccc;
}

.fixed-action-buttons-bottom {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
}

.expansion-panel {
  border-radius: 8px;
  border: 1px solid rgb(224 224 224);
}
</style>
